import { gql } from "@apollo/client";

export const CREATE_VEHICLE_GROUP = gql`
  mutation createVehicleGroup($vehicleGroup: CreateVehicleGroupInput!) {
    createVehicleGroup(vehicleGroup: $vehicleGroup) {
      id
      name
      criteria {
        type
        values
      }
      vehicles {
        id
        bodyType
        make
        model
        year
        licencePlate
        transmission
        colour
        steering
        fuelType
        features
        wheelPlan
        cylinderCapacity
        numberOfSeats
        numberOfDoors
      }
      deposit
      basePrices {
        rateTypeName
        rateTypeDuration
        rate
        longTerm
        mileageLimit
        pricePerExtraMile
      }
      isActivated
      hideInB2b2c
      yieldPricingEnabled
      excess
      protectionPlans {
        plan {
          id
          name
          excess
          description
        }
        hasFixedRate
        fixedRate
        recurringRate {
          rateTypeName
          rateTypeDuration
          rate
          longTerm
        }
        taxable
        tax {
          title
          type
          value
        } 
      }
      yieldPriceSlabs {
        yieldThreshold
        rules {
          rateType
          value
          valueType
        }
        startDate
        endDate
      }
      acrissCode
      code
    }
  }
`;
